import TermList from "../AdminTermList";

export default class AdminTermListBrightreeStopHoldType extends TermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "brightree_stop_hold_type";
  }
}
